
import PriceAndDiscountsWrapper from '@marketplace/components/product/price-and-discounts-wrapper.vue'
import ThePrice from '@marketplace/components/product/the-price.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'ProductCardInformation',

    components: {
        PriceAndDiscountsWrapper,
        ThePrice,
    },

    props: {
        url: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        brand: {
            type: String,
            default: '',
        },
        brandSlug: {
            type: String,
            default: '',
        },
        price: {
            type: [String, Number],
            default: null,
        },
        discounts: {
            type: Object,
            default: null,
        },
        currency: {
            type: String,
            default: 'EUR',
        },
        retailPrice: {
            type: [String, Number],
            default: '',
        },
        caseQuantity: {
            type: Number,
            default: 0,
        },
        quantity: {
            type: Number,
            default: 1,
        },
        inStock: {
            type: Boolean,
            default: true,
        },
        availableFrom: {
            type: String,
            default: '',
        },
        tracking: {
            type: Array,
            default: () => [],
        },
        storefront: {
            type: Object,
            default: () => {},
        },
        linkable: {
            type: Boolean,
            default: true,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        position: {
            type: String,
            default: null,
        },
        newTab: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('campaign', ['isWarehouseSale']),
        ...mapGetters('ocplus', ['hasOcPlus', 'canSeeOcPlus']),

        brandTracking() {
            const copyOfProductTracking = JSON.parse(
                JSON.stringify(this.tracking[1])
            ) // deep copy
            const trackingLocation = this.$page.currentRouteName
                ? this.$helpers.getSegmentCategoryNamebyRoute(
                      this.$page.currentRouteName
                  )
                : copyOfProductTracking?.payload?.onFavorites
                ? 'Favorites'
                : ''

            copyOfProductTracking.payload.action = `Click BrandName - ${trackingLocation}`
            return copyOfProductTracking
        },
        baseLinkTracking() {
            const { event, payload } = this.tracking[1]

            return [event, payload]
        },
        hasTrackingObject() {
            return this.tracking[0] && this.tracking[1]
        },
        hasToRoute() {
            return this.hasTrackingObject && this.linkable
        },
        categoryPath() {
            const category = this.$route?.params?.categoryPath
            if (category) {
                return `/${category}`
            }
            return ''
        },
    },
    methods: {
        fullPrice(price) {
            return price * this.quantity
        },
        discountLabel(discountsPayload) {
            return this.position === 'quickBuy'
                ? this.$t('labels.discount_off', {
                      discount: this.$n(
                          discountsPayload.percentage / 100,
                          'percent'
                      ),
                  })
                : this.$n(discountsPayload.percentage / 100, 'percent')
        },
    },
}
